import React, { useEffect, useState } from "react";
import { useAuth } from "../hooks/useAuth";
import { useNavigate } from "react-router-dom";

const CallbackPage: React.FC = () => {
    const auth = useAuth();
    const navigate = useNavigate();
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
        console.log("Callback URL:", window.location.href);
        console.log("Query params:", new URLSearchParams(window.location.search));
    }, []);

    useEffect(() => {
        if (auth.isAuthenticated) {
            navigate("/");
        }
    }, [auth.isAuthenticated, navigate]);

    if (!isClient) {
        return null;
    }

    if (auth.isLoading) {
        return <div className="loading-spinner">Chargement...</div>;
    }

    if (auth.error) {
        return (
            <div className="error-container">
                <h3>Erreur d'authentification</h3>
                <p>{auth.error}</p>
                <button onClick={() => navigate("/connexion")}>Retour à la connexion</button>
            </div>
        );
    }

    return <div className="callback-container">Traitement de la redirection...</div>;
};

export default CallbackPage;